import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './context/LanguageContext';
import { EventProvider, useEvent } from './context/EventContext';
import { Layout } from './components/Layout';
import { LoadingView, ErrorView } from './components/StateViews';
import Welcome from './pages/Welcome';
import Taste from './pages/Taste';
import MyNotes from './pages/MyNotes';
import Challenge from './pages/Challenge';
import Discover from './pages/Discover';
import VisitReims from './pages/VisitReims';
import Order from './pages/Order';
import Admin from './pages/Admin';
import './App.css';

function Guest() {
  const { status, reload } = useEvent();
  if (status === 'loading') return <div className="app-frame"><LoadingView /></div>;
  if (status === 'error') return <div className="app-frame"><ErrorView onRetry={reload} /></div>;
  return (
    <Routes>
      <Route path="/" element={<Welcome />} />
      <Route element={<Layout />}>
        <Route path="/taste" element={<Taste />} />
        <Route path="/notes" element={<MyNotes />} />
        <Route path="/challenge" element={<Challenge />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/reims" element={<VisitReims />} />
        <Route path="/order" element={<Order />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Toaster position="top-center" theme="dark" richColors />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/*" element={<EventProvider><Guest /></EventProvider>} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
